import React, { useContext, useEffect, useState } from 'react';
import { Button, Checkbox, Form, Popup, Space } from 'antd-mobile';
import cx from 'classnames';
import { message, Modal } from 'antd';
import { CloseOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useRouter } from 'next/router';
import { useRequest } from 'ahooks';
import moment from 'moment';
import { ExamMethod, TExamKind } from '@/types';
import { calcExamTitle, casLogin, judgeIsPExam } from '@/utils';
import MobileSignupPopup from '@/page-components/detail/Intro/mobile_signup_popup';
import { TCouponItem } from '@/page-components/detail/Intro/Coupon/couponItem';
import Spread from '@/page-components/detail/Intro/spread';
import ChooseExamTime from '@/page-components/detail/Intro/choose_exam_time';
import OrganizationPeopleSelect from '@/page-components/detail/Intro/OrganizationSelect/organization_people';
import MustPass from '@/page-components/detail/Intro/must_pass';
import Coupon from '@/page-components/detail/Intro/Coupon';
import {
  apiSignUpA,
  apiSignUpFCRPD,
  apiSignUpFCRPDSingle,
  apiSignUpP,
} from '@/services/exam_signup';
import { apiGetOtherPeoplePay, apiGetPExamInfo } from '@/services/exam_detail';
import { PayState } from '@/page-components/detail/Intro/exam_plan';
import { DetailContext } from '@/context/detailContext';
import styles from './styles.module.less';

type TSignupBtn = {
  type: TExamKind;
  className?: string;
  signupText?: string[];
  fcrpd_text?: string[];
  isInMobile?: boolean;
  payState?: PayState;
  coupons?: TCouponItem[];
  shouldPassOpt?: {
    id: string;
    isPass?: boolean;
    label: string;
    value: string;
    price: number;
    student_price?: number;
  }[];
};

type TMustPass = {
  id: string;
  isPass?: boolean;
  label: string;
  value: string;
  price: number;
  student_price: number | null;
  supplierPrice: number | null;
};

const SignupBtn: React.FC<TSignupBtn> = ({
  payState,
  shouldPassOpt,
  fcrpd_text = [],
  signupText = [],
  className,
  type,
}) => {
  const contextProps = useContext(DetailContext);
  const { userInfo, cert_id } = contextProps;
  const [mobileVisible, setMobileVisible] = useState(false);
  const [isMySelfSignup, setIsMySelfSignup] = useState(true);
  const [examStartTime, setExamStartTime] = useState<number>(); // 考试开始时间
  const [signupData, setSignupData] = useState<{
    shouldPrice: number;
    price: number;
    couponPrice: number;
    isAgree: boolean;
    peopleNum: number;
    method: ExamMethod;
    examDuration: number;
    couponInfo: TCouponItem;
    certTypeName: string;
    isPass: boolean;
    premise: any;
    mustPassOpt: TMustPass[];
  }>({
    certTypeName: '',
    isPass: false,
    premise: null,
    couponInfo: {
      coupon_name: '',
      coupon_purpose: '',
      coupon_id: 0,
      coupon_log_id: 0,
      coupon_value: 0,
      etime: 0,
    },
    examDuration: 0,
    method: ExamMethod.anytime,
    peopleNum: 1,
    shouldPrice: 0,
    price: 0,
    isAgree: false,
    couponPrice: 0,
    mustPassOpt: [],
  });
  const [form] = Form.useForm();

  const router = useRouter();
  const {
    uid = undefined,
    isPassRealnameAuthentication,
    isOrganizationAdmin,
    mobile,
    email,
    IDNum,
    isSupplierState,
    isPassStudentAuthentication,
  } = userInfo;
  const { run: doSignupA, loading: signupALoading } = useRequest(
    () => {
      return apiSignUpA(cert_id);
    },
    {
      manual: true,
      onSuccess: (data) => {
        console.log(data);
        console.log(`cert_id是${cert_id}`);
        if (data.code === 200) {
          router.push({
            pathname: '/exam',
            query: {
              paperId: data.data.paperId,
              examId: data.data.examId,
              type,
            },
          });
        }
      },
    },
  );
  const { loading: getPExamInfoLoading, run: getPExamInfo } = useRequest(
    () => {
      return apiGetPExamInfo(cert_id);
    },
    {
      manual: true,
      onSuccess: (res) => {
        console.log('p系列考试信息');
        console.log(res);
        if (res.code === 200) {
          const mustPassOpt = res.data.list.map((listItem) => {
            return {
              id: '',
              label: listItem.examName,
              value: listItem.examid,
              price: listItem.price,
              student_price: listItem.stuPrice,
              supplierPrice: listItem.supplierPrice,
            };
          });
          const examDuration = res.data.list.reduce(
            (acc, cur) => Number(acc) + Number(cur.duration),
            0,
          );
          setSignupData((prevState) => ({
            ...prevState,
            mustPassOpt,
            method: res.data.method,
            examDuration,
            premise: res.data.premise,
            certTypeName: res.data.certTypeName,
            isPass: res.data.isPass,
          }));
        }
      },
    },
  );
  const { run: doSignupP, loading: signupPLoading } = useRequest(
    (obj) => {
      const fixedData = {
        certId: cert_id,
        pTitle: calcExamTitle(type),
        url: window.location.href,
      };
      if (type === 'fcrpd') {
        if (obj.members) {
          return apiSignUpFCRPD({
            ...fixedData,
            ...obj,
          });
        }
        return apiSignUpFCRPDSingle({
          ...fixedData,
          ...obj,
        });
      }
      return apiSignUpP({
        ...fixedData,
        ...obj,
      });
    },
    {
      manual: true,
      onError: () => {
        message.warning('报名失败，请稍后重试');
      },
      onSuccess: (res) => {
        if (res.code === 200 && res.success) {
          if (isMySelfSignup) {
            if (res.data?.isSignupExam) {
              message.success('订单创建成功，即将跳转去支付', 2, () => {
                if (res.data.accountOrderId) {
                  window.location.href = `${process.env.NEXT_PUBLIC_PASSPORT_URL}#/orders/payment/${res.data.accountOrderId}`;
                } else {
                  window.location.href = `${process.env.NEXT_PUBLIC_PASSPORT_URL}#/orders`;
                }
              });
              setMobileVisible(false);
            } else {
              message.warning(res.msg || '报名失败，请稍后重试');
            }
          } else {
            message.success('订单创建成功，即将跳转去支付', 2, () => {
              if (res.data.accountOrderId) {
                window.location.href = `${process.env.NEXT_PUBLIC_PASSPORT_URL}/#/orders/payment/${res.data.accountOrderId}`;
              } else {
                window.location.href = `${process.env.NEXT_PUBLIC_PASSPORT_URL}/#/orders`;
              }
            });
            setMobileVisible(false);
          }
        } else {
          message.warning(res.msg || '报名失败，请稍后重试');
        }
      },
    },
  );
  const signUpExam = async (forMySelf = true) => {
    console.log(userInfo);
    if (!uid) {
      Modal.warning({
        title: '请先进行登录',
        content: '当前尚未登录',
        okText: '去登录',
        cancelText: '取消',
        onOk: () => {
          casLogin();
        },
      });
    } else if (!isPassRealnameAuthentication) {
      Modal.confirm({
        icon: <ExclamationCircleOutlined />,
        title: '请先进行初级实名认证',
        content: '认证考试报名仅对实名用户开放，认证后才可报名',
        okText: '立即认证',
        cancelText: '取消',
        onOk: () => {
          window.open(
            `${process.env.NEXT_PUBLIC_PASSPORT_URL}/?tab=auth&type=realname`,
          );
        },
      });
    } else if (!judgeIsPExam(type)) {
      // a系列直接去考试页面
      if (cert_id) {
        doSignupA();
      }
    } else {
      if (forMySelf) {
        setIsMySelfSignup(true);
      } else {
        setIsMySelfSignup(false);
      }
      let otherPayState = 1; // 检查一下是否为他人报名过fcrpd
      if (type === 'fcrpd') {
        const res = await apiGetOtherPeoplePay({ certId: cert_id });
        if (res.code === 200) {
          otherPayState = res.data.payState ? 1 : 0;
        }
      }
      if (
        (payState !== undefined && payState === 0) ||
        (!forMySelf && otherPayState === 0)
      ) {
        Modal.info({
          title: '您已经下过订单了，前往订单中心支付',
          onOk() {
            window.location.href = `${process.env.NEXT_PUBLIC_PASSPORT_URL}/#/orders/`;
          },
        });
      } else if (forMySelf && signupData.premise) {
        if (signupData.isPass) {
          setMobileVisible(true);
        } else {
          Modal.confirm({
            icon: <ExclamationCircleOutlined />,
            title: '请先通过前置认证考试',
            content: `报名本认证需要先通过${signupData.certTypeName}认证`,
            cancelText: '取消',
            okText: '立即认证',
            onOk: () => {
              router.push(`/detail/${signupData.premise}`);
            },
          });
        }
      } else {
        setMobileVisible(true);
      }
    }
  };
  // TODO 报名
  const signup = async () => {
    if (!signupData.isAgree) {
      message.warning('请勾选同意协议');
    } else {
      console.log('提交校验');
      console.log(signupData);
      const values = await form.validateFields();
      console.log(values);
      if (values.examStartTime) {
        values.examStartTime = moment(values.examStartTime).valueOf();
      }
      values.oprice = signupData.price + signupData.shouldPrice;
      delete values.must_choose;
      if (signupData?.couponInfo?.coupon_id) {
        values.couponLogId = signupData?.couponInfo?.coupon_log_id;
        values.couponId = signupData?.couponInfo?.coupon_id;
        values.couponPurpose = signupData?.couponInfo?.coupon_purpose;
      }
      if (values.select_user && Array.isArray(values.select_user)) {
        values.members = values.select_user.join(',');
      }
      await doSignupP(values);
    }
  };

  const calcMoney = (options: TMustPass[]) => {
    let money = 0;
    const calcPrice = (
      price: number,
      student_price: number | null,
      supplierPrice: number | null,
      isPass?: boolean,
    ) => {
      if (isPass) {
        return 0;
      }
      if (isOrganizationAdmin && isSupplierState) {
        /*
         * 为自己报名：供应商管理员显示供应商价格，没有的话显示学生优惠，再没有显示原价
         * 为他人报名：没有供应商价格就显示原价
         * **/
        if (isMySelfSignup) {
          if (supplierPrice) {
            return supplierPrice;
          }
          if (isMySelfSignup && student_price && isPassStudentAuthentication) {
            return student_price;
          }
          return price;
        }
        return supplierPrice || price;
      }
      if (isMySelfSignup && student_price && isPassStudentAuthentication) {
        return student_price;
      }
      return price;
    };
    options.forEach((opt) => {
      money += calcPrice(
        opt.price,
        opt.student_price,
        opt.supplierPrice,
        opt.isPass,
      );
    });
    return money;
  };

  useEffect(() => {
    if (signupData.mustPassOpt) {
      const money = calcMoney(signupData.mustPassOpt);
      setSignupData((prev) => {
        return { ...prev, price: money };
      });
    }
  }, [signupData.mustPassOpt]);
  useEffect(() => {
    if (judgeIsPExam(type) && signupData.mustPassOpt.length === 0) {
      console.log('获取报名信息接口请求');
      getPExamInfo();
    }
  }, [type]);

  return (
    <>
      {type === 'fcrpd' ? (
        <MobileSignupPopup
          isOrganizationAdmin={isOrganizationAdmin}
          className={className}
          onClick={(forMySelf) => {
            signUpExam(forMySelf);
          }}
        />
      ) : (
        <Button
          className={className}
          color="primary"
          onClick={() => signUpExam()}
        >
          {judgeIsPExam(type) ? '立即报名认证' : '立即考试'}
        </Button>
      )}
      <Popup
        destroyOnClose
        visible={mobileVisible}
        onMaskClick={() => {
          setMobileVisible(false);
        }}
        position="bottom"
        bodyClassName={styles.signup_modal_mobile}
      >
        <div className={styles.signup_modal_mobile_wrapper}>
          <div className={cx(styles.main, styles.signup_modal_wrapper_left)}>
            <header className={styles.header}>
              {isMySelfSignup ? '认证报名' : '为他人报名'}
              <CloseOutlined
                className={styles.close_icon}
                onClick={() => {
                  setMobileVisible(false);
                }}
              />
            </header>
            <section className={styles.info_wrapper}>
              <Spread
                signupText={
                  type === 'fcrpd' && !isMySelfSignup ? fcrpd_text : signupText
                }
              />
            </section>
            <section className={styles.info_list_wrapper}>
              <div className={styles.info_list_wrapper_item}>
                <p className={styles.tips_text}>考试时长</p>
                <p className={styles.data_text}>
                  {signupData.examDuration}分钟
                </p>
              </div>
              <div className={styles.info_list_wrapper_item}>
                <p className={styles.tips_text}>身份证号</p>
                <p className={styles.data_text}>{IDNum}</p>
              </div>
              <div className={styles.info_list_wrapper_item}>
                <p className={styles.tips_text}>手机号</p>
                <p className={styles.data_text}>{mobile}</p>
                <a
                  href={process.env.NEXT_PUBLIC_PASSPORT_URL}
                  className={styles.link_text}
                >
                  修改手机号
                </a>
              </div>
              <div className={styles.info_list_wrapper_tips_row}>
                手机号用于接收报名信息，考试成绩提醒，请确认填写无误
              </div>
              <Form form={form}>
                {signupData.method !== ExamMethod.anytime && (
                  <ChooseExamTime
                    certId={cert_id}
                    method={signupData.method}
                    onSchTimeChange={(time) => {
                      console.log('time是');
                      console.log(time);
                      setExamStartTime(time);
                    }}
                  />
                )}
                {signupData.mustPassOpt.length > 0 && (
                  <div className={styles.row}>
                    <MustPass
                      isMySelfSignup={isMySelfSignup}
                      mobileFormInstance={form}
                      data={signupData.mustPassOpt}
                    />
                  </div>
                )}
                {/*{shouldPassOpt && (*/}
                {/*  <ShouldPass*/}
                {/*    mobileFormInstance={form}*/}
                {/*    isPassStudentAuthentication={userInfo.isPassStudentAuthentication}*/}
                {/*    passNum={1}*/}
                {/*    data={shouldPassOpt}*/}
                {/*    onChange={(checkValue) => {*/}
                {/*      console.log('checkValue');*/}
                {/*      console.log(checkValue);*/}
                {/*      const options = shouldPassOpt?.filter(opt => checkValue.includes((opt.value)));*/}
                {/*      const money = calcMoney(options);*/}
                {/*      setSignupData(prev => {*/}
                {/*        return {...prev, shouldPrice: money}*/}
                {/*      })*/}
                {/*    }}*/}
                {/*  />*/}
                {/*)}*/}
                {!isMySelfSignup && (
                  <OrganizationPeopleSelect
                    certId={cert_id}
                    mobileFormInstance={form}
                    onChange={(data) => {
                      console.log('btn接收到了');
                      console.log(data);
                      setSignupData((prev) => {
                        return { ...prev, peopleNum: data.length || 1 };
                      });
                    }}
                  />
                )}
              </Form>
              <Coupon
                type={type}
                isMySelfSignup={isMySelfSignup}
                isOrganizationAdmin={isOrganizationAdmin}
                onChange={(receiveCoupons) => {
                  let couponPrice = 0;
                  receiveCoupons.forEach((coupon) => {
                    couponPrice += coupon.coupon_value;
                  });
                  setSignupData({
                    ...signupData,
                    couponPrice,
                    couponInfo: receiveCoupons[0],
                  });
                }}
              />
            </section>
          </div>
          <div className={styles.footer}>
            <div className={styles.checkbox_row}>
              <Checkbox
                style={{
                  '--font-size': '12px',
                  '--icon-size': '16px',
                }}
                onChange={(check) => {
                  console.log(check);
                  setSignupData((prev) => ({ ...prev, isAgree: check }));
                }}
              >
                我已阅读并同意
                <a
                  rel="noreferrer"
                  href="https://bbs.fanruan.com/thread-132684-1-1.html"
                  target="_blank"
                >
                  《帆软认证考试服务协议》
                </a>
              </Checkbox>
            </div>
            <div className={styles.row}>
              <Space>
                合计
                <span className={styles.price_text}>
                  ￥
                  {signupData.price +
                    signupData.shouldPrice -
                    signupData.couponPrice <=
                  0
                    ? 0
                    : signupData.peopleNum *
                        (signupData.price + signupData.shouldPrice) -
                      signupData.couponPrice}
                </span>
              </Space>
              <Button color="primary" onClick={signup}>
                确认报名
              </Button>
            </div>
          </div>
        </div>
      </Popup>
    </>
  );
};
export default SignupBtn;
